import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "#009919",
  heroBackgroundEn: `white`,
  heroBackgroundHe: `white`,
  heroTextColor: "black",
  heroSvgIconColor: "#0C723B",
  filterModalHeaderColor: "rgba(12, 114, 59, 0.05)",
  filterModalHeaderTextColor: "#000",
  footerColor: "#009919",
  navBackgroundColor: "white",
  navTextColor: "black",
  selectedNavTextColor: "black",
  selectedSubNavTextColor: "black",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#009919",
  footerLogoLinkBackgroundColor: "transparent",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #009919 0%, #064021 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #064021 0%, #009919 100%)",
  numberGridBorderColor: "#009919",
  newNumberGridTextColor: "#009919",
  accordionPanelBackgroundColor: "rgba(12, 114, 59, 0.4)",
  jobsQuoteGalleryBackgroundColor: "#009919",
  teamContainerBackgroundColor: "#009919",
  buttonHoverBackgroundColor: "#009919",
  buttonActiveBackgroundColor: "#009919",
  buttonHoverTextColor: "white",
  paginationBackgroundColor: "#009919",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#009919",
  faqTextColorExpanded: "#009919",
  faqTextColorHover: "#009919",
  faqRootBackground: "white",
  faqRootInsideBackground: "white",
  faqRootInsideBackgroundHover: "white",
  faqRootInsideColorHover: "black",
  faqBorderColor: "#F7F7F7",
  faqTextColor: "#000",
  faqIconColor: "#009919",
  faqIconColorAlternative: "#000",
  faqBoxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
  faqTitleBorderBottom: "#009919",
  jobCardTopHeader: "#000",
  heroBgFallback: "#009919",
}

export default colors
